module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門2_6.16346e5c.png";